import { useState, useCallback } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const useZipValidation = () => {
  const [validating, setValidating] = useState(false);
  const [validation, setValidation] = useState(null);
  const [error, setError] = useState(null);

  const validateZip = useCallback(async (zipCode) => {
    if (!zipCode || zipCode.length < 5) {
      setValidation(null);
      return null;
    }

    setValidating(true);
    setError(null);
    
    try {
      const response = await axios.post(`${API_URL}/api/service-areas/validate-zip`, {
        zip_code: zipCode.trim()
      });
      setValidation(response.data);
      return response.data;
    } catch (err) {
      setError('Unable to validate ZIP code');
      return null;
    } finally {
      setValidating(false);
    }
  }, []);

  const quickCheck = useCallback(async (zipCode) => {
    if (!zipCode || zipCode.length < 5) return null;
    
    try {
      const response = await axios.get(`${API_URL}/api/service-areas/check-zip/${zipCode.trim()}`);
      return response.data;
    } catch (err) {
      return null;
    }
  }, []);

  const clearValidation = useCallback(() => {
    setValidation(null);
    setError(null);
  }, []);

  return {
    validateZip,
    quickCheck,
    clearValidation,
    validating,
    validation,
    error,
    isServiceable: validation?.is_serviceable ?? null,
    serviceAreaName: validation?.service_area_name ?? null
  };
};

export default useZipValidation;
